import { ClientFinances } from 'types/state';

export function createClientFinances(): ClientFinances {
  return {
    balanceAmount: 0,
    incomeAmount: 0,
    partnerPartAmount: 0,
    agmPartAmount: 0,
  };
}

export function createClientFinancesMock(): ClientFinances {
  return {
    balanceAmount: 10,
    incomeAmount: 120,
    partnerPartAmount: 80,
    agmPartAmount: 40,
  };
}
